<template lang="pug">
.homepageComponent
  homepage-section1(:cursor="cursor").section._1
  homepage-section2.section._2
  homepage-section3(:cursor="cursor").section._3
  homepage-section4(:cursor="cursor").section._4
  homepage-section5(:cursor="cursor").section._5
  homepage-section6(:cursor="cursor").section._6
  homepage-section7.section._7
  homepage-section8.section._8
</template>

<script>
import { inject, reactive, onMounted, onUnmounted } from 'vue'
import { useRouter } from 'vue-router'
import { LS_HOMEPAGE_WANTS_PURCHASE, LS_HOMEPAGE_WANTS_DEMO } from '@/config'
import HomepageSection1 from '@/components/Homepage/HomepageSection1'
import HomepageSection2 from '@/components/Homepage/HomepageSection2'
import HomepageSection3 from '@/components/Homepage/HomepageSection3'
import HomepageSection4 from '@/components/Homepage/HomepageSection4'
import HomepageSection5 from '@/components/Homepage/HomepageSection5'
import HomepageSection6 from '@/components/Homepage/HomepageSection6'
import HomepageSection7 from '@/components/Homepage/HomepageSection7'
import HomepageSection8 from '@/components/Homepage/HomepageSection8'
import PurchaseModal from '@/components/Homepage/PurchaseModal/PurchaseModal'
export default {
  name: 'Homepage',
  components: {
    HomepageSection1,
    HomepageSection2,
    HomepageSection3,
    HomepageSection4,
    HomepageSection5,
    HomepageSection6,
    HomepageSection7,
    HomepageSection8
  },
  setup () {
    const store = inject('store')
    const router = useRouter()

    const onUserLoaded = () => {
      if (store.user.isAuthenticated) {
        if (localStorage.getItem(LS_HOMEPAGE_WANTS_PURCHASE)) {
          store.modalQueue.push({
            key: 'purchase',
            component: PurchaseModal
          })
        } else if (localStorage.getItem(LS_HOMEPAGE_WANTS_DEMO)) {
          router.push({ name: 'Catalog' })
        }
        localStorage.removeItem(LS_HOMEPAGE_WANTS_PURCHASE)
        localStorage.removeItem(LS_HOMEPAGE_WANTS_DEMO)
      }
    }

    store.user.$on('requestSubscriptions-success', onUserLoaded)

    // cursor
    const cursor = reactive({})
    const _onMousemove = e => {
      setTimeout(() => {
        cursor.x = e.clientX / window.innerWidth
        cursor.y = e.clientY / window.innerHeight
      }, 200)
    }
    onMounted(() => {
      window.addEventListener('mousemove', _onMousemove)
    })
    onUnmounted(() => {
      window.removeEventListener('mousemove', _onMousemove)
    })

    return {
      cursor
    }
  }
}
</script>

<style lang="sass" scoped>
.homepageComponent
  position: relative
  width: 100vw
  left: calc(-1*(100vw - 100%)/2)
  font-family: GolosTextWebRegular, serif
  line-height: 1.45

  .section
    &._1
      padding-top: 15*$u
      :deep()
        .sectionContainer
          padding-right: 0
          @media (max-width: $XLWidth)
            padding-right: $appSidePaddingMobile

    &._2
      padding-top: 20*$u
      padding-bottom: 20*$u
      @media (max-width: $padWidth)
        padding-top: 13*$u
        padding-bottom: 13*$u
    &._3
    &._4
    &._5
    &._6
    &._7
      padding-top: 25*$u
      padding-bottom: 38*$u
      @media (max-width: $padWidth)
        padding-top: 13*$u
        padding-bottom: 13*$u
    &._8
      padding-top: 20*$u
      padding-bottom: 20*$u
      @media (max-width: $padWidth)
        padding-top: 13*$u
        padding-bottom: 13*$u

  :deep()
    .sectionContainer
      max-width: $appMaxWidth
      margin: 0 auto
      padding: 0 $appSidePaddingDesktop
      @media (max-width: $padWidth)
        padding: 0 $appSidePaddingMobile
</style>
